var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.335 8.95868V16.7712C18.3348 17.6336 17.6348 18.3335 16.7725 18.3337H3.23047C2.36795 18.3337 1.66814 17.6337 1.66797 16.7712V8.95868H18.335ZM9.48047 1.66669V7.91669H1.70996C1.72298 7.83531 1.72298 7.7536 1.74902 7.67548L3.39648 2.73407C3.60816 2.09621 4.2042 1.66669 4.87793 1.66669H9.48047ZM15.125 1.66669C15.7988 1.66669 16.3948 2.09616 16.6064 2.73407L18.2529 7.67548C18.279 7.75358 18.279 7.83532 18.292 7.91669H10.5225V1.66669H15.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResource);
export default __webpack_public_path__ + "static/media/resource.d43587397e61c275e332680916b079fa.svg";
export { ForwardRef as ReactComponent };